import { shippingOptionWidgetSchema } from "@redotech/redo-model/checkouts/checkout-widget";
import * as z from "zod";

export const getShippingOptionWidgets = {
  name: "getShippingOptionWidgets" as const,
  input: z.void(),
  output: z.array(shippingOptionWidgetSchema),
};
